import React from 'react'

const CantiquesEdit = () => {
  return (
    <div>CantiquesEdit</div>
  )
}

export default CantiquesEdit